import * as THREE from 'three'
interface Props {
  position: any
  geometry: any
  material: any
}

export const LedSpot = ({
  position,
  geometry,
  material,
  ...props
}: Props): JSX.Element => {
  return (
    <group dispose={null}>
      <mesh
        castShadow={true}
        receiveShadow={true}
        // args={[2.5, 2.5, 0.5]}
        position={position}
        geometry={geometry}
        material={material}
      ></mesh>
    </group>
  )
}
